import { frontendURL } from '../../../../helper/URLHelper';

const campaigns = accountId => ({
  parentNav: 'campaigns',
  routes: [
    'ongoing_campaigns',
    'one_off',
    'campaigns_suppressions',
    'email_campaigns_domains',
    'email_campaigns_domain_show',
    'email_campaigns_senders',
    'email_campaigns_postal_address',
  ],
  menuItems: [
    {
      icon: 'arrow-swap',
      label: 'ONGOING',
      key: 'ongoingCampaigns',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/campaigns/ongoing`),
      toStateName: 'ongoing_campaigns',
    },
    {
      key: 'oneOffCampaigns',
      icon: 'sound-source',
      label: 'ONE_OFF',
      hasSubMenu: false,
      toState: frontendURL(`accounts/${accountId}/campaigns/one_off`),
      toStateName: 'one_off',
    },
    {
      key: 'emailCampaignDomains',
      icon: 'mail',
      label: 'EMAIL_CAMPAIGNS_DOMAINS',
      hasSubMenu: false,
      meta: { permissions: ['administrator'] },
      toState: frontendURL(
        `accounts/${accountId}/campaigns/email-campaigns/domains`
      ),
      toStateName: 'email_campaigns_domains',
      requiresEmailCampaigns: true,
    },
    {
      key: 'emailCampaignSenders',
      icon: 'mail-inbox',
      label: 'EMAIL_CAMPAIGNS_SENDERS',
      hasSubMenu: false,
      meta: { permissions: ['administrator'] },
      toState: frontendURL(
        `accounts/${accountId}/campaigns/email-campaigns/senders`
      ),
      toStateName: 'email_campaigns_senders',
      requiresEmailCampaigns: true,
    },
    {
      key: 'campaignSuppressions',
      icon: 'dismiss-circle',
      label: 'EMAIL_CAMPAIGNS_SUPPRESSIONS',
      hasSubMenu: false,
      meta: { permissions: ['administrator'] },
      toState: frontendURL(`accounts/${accountId}/campaigns/suppressions`),
      toStateName: 'campaigns_suppressions',
      requiresEmailCampaigns: true,
    },
    {
      key: 'emailCampaignPostalAddress',
      icon: 'location',
      label: 'EMAIL_CAMPAIGNS_POSTAL_ADDRESS',
      hasSubMenu: false,
      meta: { permissions: ['administrator'] },
      toState: frontendURL(
        `accounts/${accountId}/campaigns/email-campaigns/postal-address`
      ),
      toStateName: 'email_campaigns_postal_address',
      requiresEmailCampaigns: true,
    },
  ],
});

export default campaigns;
